import { api } from '../services';
export const getIntegration = async (subdomain) => api.get(`/communities/${subdomain}/plugins`);
export const disconnectIntegration = async (subdomain, name) => api.delete(`/communities/${subdomain}/plugins/${name}`);
export const getGuildInfo = async (subdomain) => api.get(`/communities/${subdomain}/plugins/discord/guild`);
export const updateDiscordIntegration = async (subdomain, options) => api.post(`/communities/${subdomain}/plugins/discord/update`, {
    body: JSON.stringify(options),
});
export const getFailedAutomations = async (subdomain) => api.get(`/communities/${subdomain}/failed-discord-integration`);
export const resendFailedDiscordRoles = async (subdomain) => api.post(`/communities/${subdomain}/resend-failed-discord-roles`);
